export function groupBy<T>(array: T[], groupBy: (item: T) => string) {
  // Using a Map to store the groups
  const groups = new Map<string, T[]>()

  // Iterate over the array and group the items
  array.forEach((item) => {
    const key = groupBy(item)

    if (!groups.has(key)) {
      groups.set(key, [])
    }

    groups.get(key)?.push(item)
  })

  return groups
}
